import React, { FC } from "react";
import { useFormikContext } from "formik";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { IRegisterValues } from "src/@types/auth";
import { ReactComponent as ArrowTopIcon } from "src/assets/icons/arrow_top.svg";
import { registrationButtonsTrns } from "./trns";
import { AuthFormButton } from "../AuthFormButton";

interface Props {
  isFirstStep: boolean;
  isLastStep: boolean;
  onNextClick: VoidFunction;
  onPrevClick: VoidFunction;
  isLoading: boolean;
}

export const StepControls: FC<Props> = ({
  isFirstStep,
  isLastStep,
  isLoading,
  onNextClick,
  onPrevClick,
}) => {
  const { t } = useTranslation();
  const { errors, touched } = useFormikContext<IRegisterValues>();

  const errorKeys = Object.keys(errors);
  const isShownError = errorKeys.some((fieldName) => touched[fieldName]);

  if (isLastStep) {
    return (
      <div className="flex items-center gap-2">
        <Button
          className={cn(
            "flex-1 gap-1 text-base lg:px-5 lg:py-3 lg:text-xl font-semibold lg:hidden",
            {
              "bg-red-light lg:bg-purple-base": isShownError,
            }
          )}
          variant={ButtonVariants.PRIMARY}
          type="button"
          onClick={onPrevClick}
        >
          <ArrowTopIcon className="fill-svg-white-base -rotate-90 w-5 h-5" />

          <span>{t(registrationButtonsTrns.prevButton)}</span>
        </Button>
        <AuthFormButton
          className={cn(
            "flex-1 gap-1 text-base lg:px-5 lg:py-2 font-semibold lg:flex-initial lg:min-h-11 lg:mx-auto lg:!w-1/2",
            {
              "bg-red-light lg:bg-purple-base": isShownError,
            }
          )}
          isLoading={isLoading}
        >
          {t(registrationButtonsTrns.submitButton)}
        </AuthFormButton>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        className={cn(
          "flex-1 gap-1 text-base lg:px-5 lg:py-3 lg:text-xl font-semibold lg:hidden",
          {
            "bg-red-light": isShownError,
          }
        )}
        variant={ButtonVariants.PRIMARY}
        type="button"
        onClick={onPrevClick}
        isDisabled={isFirstStep}
      >
        <ArrowTopIcon className="fill-svg-white-base -rotate-90 w-5 h-5" />

        <span>{t(registrationButtonsTrns.prevButton)}</span>
      </Button>

      <Button
        className={cn(
          "flex-1 gap-1 text-base lg:px-5 lg:py-3 lg:text-xl font-semibold lg:flex-initial",
          {
            "bg-red-light lg:bg-purple-base": isShownError,
          }
        )}
        variant={ButtonVariants.PRIMARY}
        type="button"
        onClick={onNextClick}
      >
        <span>{t(registrationButtonsTrns.nextButton)}</span>

        <ArrowTopIcon className="fill-svg-white-base rotate-90 w-5 h-5" />
      </Button>
    </div>
  );
};
